import React, { useState } from "react";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { useRef, useEffect } from "react";
import CamplaCoreService from "../../../services/CamplaCoreService";

const AuditorsAsyncTypeAhead = ({
  onSelected,
  clear,
  onClear,
  emptyLabel = "Keine Ergebnisse",
  promptText = "Searching...",
  placeholder = "Search...",
  valid,
  handleAddMember,
  users,
  validation,
  onInputChange,
  moduleClasses,
  classMembers
}) => {
  const [emailList, setEmailList] = useState([]);
  const [inputText, setInputText] = useState("");
  const typeaheadRef = useRef();

  const handleKeyPress = (event) => {
    if (event.key === "Enter" && valid) {
      handleAddMember();
    }
  };

  useEffect(() => {
    // Exclude own user
    const currentUser = CamplaCoreService.getAuthenticatedUser();
    const userEmails = users
        .filter(user => user.email !== currentUser.email)
        .map(user => user.email);
    const validatedEmail = new Set(
        validation.auditors.value?.map((el) => el.email),
    );

    let filteredList ;

    if (classMembers && classMembers.length > 0) {
      const members = new Set(classMembers.map(m => m.email));
      filteredList = userEmails
          .filter(email => !members.has(email))
          .filter(email => !validatedEmail.has(email));
    }else if (moduleClasses && moduleClasses.length > 0) {
      const selectedModuleClasses = moduleClasses.filter(mc => validation.moduleClasses.value.indexOf(mc._id) !== -1);
      const members = new Set(selectedModuleClasses.flatMap(mc => mc.members).map(m => m.email));
      filteredList = userEmails
          .filter(email => !members.has(email))
          .filter(email => !validatedEmail.has(email));
    }else{
      filteredList = [];
    }

    setEmailList(filteredList);

  }, [users, validation]);

  useEffect(() => {
    if (clear && typeaheadRef.current) {
      typeaheadRef.current.clear();
      onClear();
      typeaheadRef.current.focus();
    }
  }, [clear, onClear]);

  const handleChange = (selected) => {
    onSelected(selected);
  };

  useEffect(() => {
    onInputChange(inputText);
  }, [inputText]);

  return (
    <AsyncTypeahead
      onInputChange={(text) => setInputText(text)}
      style={{
        borderBottomRightRadius: "0px",
        borderTopRightRadius: "0px",
      }}
      className="custom-typeahead"
      minLength={3}
      ref={typeaheadRef}
      isLoading={false}
      onSearch={() => {}}
      options={emailList}
      labelKey="name"
      placeholder={placeholder}
      onChange={handleChange}
      id="Email"
      autoFocus={true}
      emptyLabel={emptyLabel}
      promptText={promptText}
      onKeyDown={(event) => handleKeyPress(event)}
    />
  );
};

export default AuditorsAsyncTypeAhead;
